export default "__VITE_ASSET__CbJohvtv__"